module.exports = __webpack_public_path__ + "static/ULC Organisation-1cc5027bd433df556f05de0d83d6ad7f.jpg";